import loadingsTemplates from './loadingsTemplates';
import { DefaultLoading } from './loadingsLayouts';

const loadingsSet = [
  {
    component: DefaultLoading,
    codeTemplate: loadingsTemplates.deafault,
    optionsGroup: [
      {
        label: 'Standard',
        options: [
          { label: 'large', type: 'radio', options: {large: true, small: false}},
          { label: 'small', type: 'radio', options: {large: false, small: true}},
        ]
      },
      {
        label: 'Background',
        options: [
          { label: 'light', type: 'radio', options: {dark: false, bgColor: null} },
          { label: 'dark', type: 'radio', options: {dark: true, bgColor: 'black'} },
        ]
      },
    ],
  },
  {
    component: DefaultLoading,
    codeTemplate: loadingsTemplates.simple,
    optionsGroup: [
      {
        label: 'Simple',
        options: [
          { label: 'dafault', type: 'radio', options: {simple: true}}
        ]
      },
      {
        label: 'Background',
        options: [
          { label: 'light', type: 'radio', options: {dark: false, bgColor: null, simple: true}},
          { label: 'dark', type: 'radio', options: {dark: true, bgColor: 'black', simple: true}},
        ]
      },
    ],
  },
];

export default loadingsSet;



// WEBPACK FOOTER //
// ./src/containers/elements/Loadings/constants/loadingsSet.js